export default {
  message: {
    welcome:'欢迎来到华岩巨筑',
    search: '搜索',
    placeHolder:'请输入关键字进行搜索',
    quantity:'数量',
    color: '颜色',
    design: '设计基础',
    specifications: '规格',
    China: '中国',
    MinimumOrder: '最小订单',
    squareMeter:'平方米',
    thickness:'厚度',
    price:'价格',
    material:'材料',
    sendEmail:'发送邮件',
    phoneCall:'打电话',
    ProductDetails:'产品详情',
    Ltd:'许昌石淘城石业有限公司',
    name:'王宁波',
    Tel:'电话',
    SalesManager:'销售经理',
    ContactTheSupplier:'联系供应商',
    languageList:{
      item0:'简体中文',
      item1:'英文',
      item2:'阿拉伯语',
      item3:'越南语',
      // item4:'印尼语'
    },
    desc:'华岩巨筑通过产业互联网，建立完善的全球石材供应链体系，建立自己的产品矩阵，优化产业上下游的生态布局，从2020年成立以来，近20个中心门店覆盖河南、安徽、 山东、湖南、河北、天津、北京，主营岗石年销量360万方，成为国内最大岗石产销商，花岗岩300万方，石英石50多万方，岩板20多万方，成为国内行业的领先者。 通过互联网的方式，不断优化供应链结构来提供更优质的服务，改良现有的零售模式，使用大数据和智能化软硬件，突破固有的石材批发体验。'
    
  }
}